import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    leadWrapper: {
      display: "flex",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: "12px",
    },
    contactOverViewCard: {
      padding: "24px",
    },
    rounded: {
      borderRadius: "20px",
    },
    leadCardTitleWrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderBottom: `1px solid ${theme.palette.border.secondary}`,
      paddingBottom: "20px",
    },
    titleContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: "8px ",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        minWidth: "60px",
      },
    },
    leadContainer: {
      marginTop: "20px",
      display: "flex",
      flexDirection: "column",
      gap: "24px",
    },
    infoSection: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
    },
    headingSection: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "12px",
    },
    infoItem: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
  };
});
